import PDF from './PDFWrapper'

export default PDF;